import slugify from '@/helpers/slugify';
import constances from '@/configs/constances';
import HTTP from '@/services/HTTP';

import { set } from '../storeHelpers';

const state = {
  containerClass: '',
  languages: [
    { label: 'English', value: 'en' },
    { label: 'Polish', value: 'pl' }
  ],
  userRoles: [
    { value: constances.roles.RECYCLER, label: 'Recycler' },
    { value: constances.roles.AUDITOR, label: 'Auditor' },
    { value: constances.roles.REPRESENTATIVE, label: 'Recovinyl Regional Representative' },
    { value: constances.roles.SECTOR_ASSOCIATION_REPRESENTATIVE, label: 'Sector Association Representative' },
  ],
  staticPages: {},
  staticPage: {},
  logoPath: '',
};

const actions = {
  async getStaticPages({ commit }) {
    try {
      const { data } = await HTTP.get('pages');
      if (data.length) {
        commit('setStaticPages', data);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async getStaticPage({ commit }, pageId) {
    try {
      const { data } = await HTTP.get(`pages/${pageId}`);
      commit('setStaticPage', data);
    } catch (error) {
      console.error(error);
    }
  },
  async updateStaticPage(_, pageData) {
    const { id, title, content } = pageData;
    return HTTP.put(`pages/${id}`, {
      title,
      content
    });
  },
  async checkVat(_, { country_code, vat_number }) {
    return HTTP.get('/auth/check-vat', {
      params: {
        country_code,
        vat_number
      }
    });
  },
  async getLogo({ commit }) {
    try {
      const { data } = await HTTP.get('configuration/logo');
      if (data[0]) {
        const { path } = JSON.parse(data[0].content);
        commit('setLogoPath', path);
      }
    } catch (error) {
      console.error(error);
    }
  },
  async getChangesList(_, { tableName, recordId }) {
    try {
      const { data } = await HTTP.get(`/configuration/revisions/${tableName}/${recordId}`);
      console.info('Implement this in new wersion', data);
    } catch (error) {
      console.error(error);
    }
  },
};

const mutations = {
  setContainerClass: set('containerClass'),
  setStaticPages(state, staticPages) {
    const staticPagesObj = {};
    staticPages.forEach(page => {
      staticPagesObj[page.id] = {
        title: page.title,
        slug: slugify(page.title)
      };
    });
    state.staticPages = staticPagesObj;
  },
  setStaticPage: set('staticPage'),
  setLogoPath(state, logoPath) {
    state.logoPath = `${constances.domainUrl}/${logoPath}`;
  }
};

/**
 * Main app store data
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
